export function publications() {
  function live(eventType, elementId, cb) {
    document.addEventListener(eventType, function (event) {
      var el = event.target,
        found;

      while (el && !(found = el.id === elementId)) {
        el = el.parentElement;
      }

      if (found) {
        cb.call(el, event);
      }
    });
  }

  /**
   * Open publication download in new tab
   */
  if (document.querySelector("#publication_form")) {
    live("submit", "publication_form", function (event) {
      if (
        document.querySelector("#publication_download_button") &&
        document.querySelector("#publication_download_button a").href.length > 0
      )
        // window.open( document.querySelector( '#publication_download_button a' ).href, '_blank' )
        document.querySelector("#publication_download_button a").click();
    });

    // document
    //     // .querySelector( '#publication_form button' )
    //     .addEventListener( 'click ', e => {
    //         console.log( 'fired' )
    //         if (
    //             document.querySelector( '#publication_download_button' )
    //             &&
    //             document.querySelector( '#publication_download_button a' ).href.length > 0
    //         )
    //             // window.open( document.querySelector( '#publication_download_button a' ).href, '_blank' )
    //             document.querySelector( '#publication_download_button a' ).click()
    //
    //     } )
  }
}
